import { useTranslation } from 'react-i18next';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaShareSquare } from 'react-icons/fa';
import Button from 'react-bootstrap/Button';

function ReferButton({ handler, label }: { handler: () => void, label: string }): JSX.Element {
  const { t } = useTranslation();

  return (
    <OverlayTrigger
      trigger={['hover', 'focus']}
      placement="left"
      overlay={(
        <Tooltip id="{key}-tooltip">
          {t('Refer_PDP_Action_Description')}
        </Tooltip>
      )}
    >
      <Button variant="link" className="linkactions" onClick={handler}>
        <FaShareSquare />
        {label && (<span>{label}</span>)}
      </Button>
    </OverlayTrigger>
  );
}

export default ReferButton;
